import React from 'react';
import PropTypes from 'prop-types';
import { CgSpinner } from 'react-icons/cg';
import { Box, Typography } from '@mui/material';

const Spinner = ({inline = true, message = ''}) => {

    const loaderMsg = message || 'Loading...';

    if (!inline) {
        return (
            <div style={{width: '100%', height: '100%', display: 'grid', placeItems: 'center'}}>
                <Box>
                    <CgSpinner size={20} className='mt-1 animate-spin' />
                    <Typography variant="h6" gutterBottom>
                        {loaderMsg}
                    </Typography>
                </Box>
            </div>
        );
    }

    return (
        <CgSpinner size={20} className='mt-1 animate-spin' />
    );
};

export default Spinner;

Spinner.propTypes = {
    inline: PropTypes.bool,
    message: PropTypes.string,
};